import { connect } from 'react-redux';

import { RANDOMIZATION_HYPOTHESIS_TESTING_FORM } from 'store/form';

import {
  getSamplesMean, getSamplesStdev
} from 'store/scenes/randomizationHypothesisTesting/samples/selectors';

import CIFieldsComponent from 'components/CIFields';

const mapStateToProps = state => ({
  form: RANDOMIZATION_HYPOTHESIS_TESTING_FORM,

  mean: getSamplesMean(state),
  stdev: getSamplesStdev(state)
});

export default connect(mapStateToProps)(CIFieldsComponent);
